interface IconProps {
  color?: string;
  className?: string;
}

export default function RouteIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23.5321"
        height="23.5321"
        rx="4.5"
        stroke={color}
      />
      <g clipPath="url(#clip0_6675_62306)">
        <path
          d="M15.2205 8.34068C15.543 8.34068 15.8044 8.07925 15.8044 7.75676C15.8044 7.43428 15.543 7.17285 15.2205 7.17285C14.898 7.17285 14.6366 7.43428 14.6366 7.75676C14.6366 8.07925 14.898 8.34068 15.2205 8.34068Z"
          fill={color}
        />
        <path
          d="M8.81423 15.5487C9.13671 15.5487 9.39814 15.2873 9.39814 14.9648C9.39814 14.6423 9.13671 14.3809 8.81423 14.3809C8.49174 14.3809 8.23032 14.6423 8.23032 14.9648C8.23032 15.2873 8.49174 15.5487 8.81423 15.5487Z"
          fill={color}
        />
        <path
          d="M15.3824 14.0345H12.8652C12.0913 14.0345 11.4599 13.4059 11.4599 12.6292C11.4599 11.8525 12.0885 11.2239 12.8652 11.2239H15.6786C15.8965 11.2239 16.0753 11.0451 16.0753 10.8271C16.0753 10.6595 15.9719 10.517 15.8267 10.4584C16.3156 9.79901 17.0867 8.65074 17.0867 7.96066C17.0867 6.93253 16.2513 6.09717 15.2232 6.09717C14.1951 6.09717 13.3597 6.93253 13.3597 7.96066C13.3597 8.64236 14.1085 9.76548 14.5974 10.4304H12.8652C11.6527 10.4304 10.6664 11.4166 10.6664 12.6292C10.6664 13.8417 11.6527 14.8279 12.8652 14.8279H15.3824C16.1563 14.8279 16.7877 15.4565 16.7877 16.2332C16.7877 17.0099 16.1591 17.6385 15.3824 17.6385H9.43716C9.92608 16.9764 10.6748 15.8533 10.6748 15.1688C10.6748 14.1406 9.83947 13.3053 8.81134 13.3053C7.7832 13.3053 6.94785 14.1406 6.94785 15.1688C6.94785 15.8616 7.72174 17.0155 8.21066 17.672C8.07097 17.7335 7.97598 17.8732 7.97598 18.0352C7.97598 18.2532 8.15478 18.432 8.3727 18.432H15.3769C16.5894 18.432 17.5756 17.4457 17.5756 16.2332C17.5756 15.0207 16.5894 14.0345 15.3769 14.0345H15.3824ZM14.0973 7.96345C14.0973 7.34601 14.6002 6.84033 15.2204 6.84033C15.8406 6.84033 16.3435 7.34322 16.3435 7.96345C16.3435 8.33783 15.8071 9.24024 15.2204 10.0309C14.6365 9.24024 14.0973 8.33783 14.0973 7.96345ZM7.69101 15.1688C7.69101 14.5513 8.1939 14.0456 8.81413 14.0456C9.43436 14.0456 9.93725 14.5485 9.93725 15.1688C9.93725 15.5431 9.40084 16.4456 8.81413 17.2362C8.23022 16.4456 7.69101 15.5431 7.69101 15.1688Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6675_62306">
          <rect
            width="10.6306"
            height="12.332"
            fill="white"
            transform="translate(6.95074 6.1001)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
